import type { AuthenticationV1Account, AuthenticationV1ErrorCode } from '@sdk/Api'
import { persisted } from '@square/svelte-store'
import { derived, writable } from 'svelte/store'

export const accountOrErrorCode = writable<AuthenticationV1Account | AuthenticationV1ErrorCode>(
	null,
)

export const originalAccount = writable<AuthenticationV1Account | AuthenticationV1ErrorCode>(null)

export const impersonatedAccount = persisted<{ accountId: string; name: string }>(
	null,
	'impersonatedAccount',
	{ reloadable: true },
)

export const account = derived([accountOrErrorCode], ([accountOrError]) => {
	if (typeof accountOrError === 'string') {
		return null
	}

	return accountOrError
})
